@if (useChip) {
  <ds-chip
    data-test-id="viewport"
    [iconName]="chipIcon"
    [showIcon]="hasChipIcon"
    [colorVariant]="DsChipColorVariant.Light"
    [text]="chipText"
  ></ds-chip>
} @else {
  <span data-test-id="viewport">
    <span class="px-1">
      @switch (scanViewport.viewportType) {
        @case (viewportType.mobile) {
          <svg height="18" width="18" fill="none" [attr.aria-label]="'scan_viewport_mobile' | translate">
            <use xlink:href="#mobile-viewport-icon"></use>
          </svg>
        }
        @case (viewportType.tablet) {
          <svg height="18" width="18" fill="none" [attr.aria-label]="'scan_viewport_tablet' | translate">
            <use xlink:href="#tablet-viewport-icon"></use>
          </svg>
        }
        @case (viewportType.desktop) {
          <svg height="18" width="18" fill="none" [attr.aria-label]="'scan_viewport_desktop' | translate">
            <use xlink:href="#desktop-viewport-icon"></use>
          </svg>
        }
      }
    </span>
    <span class="px-1">{{ 'scan_viewport_' + scanViewport.viewportType | translate }}</span>
    @if (!hideViewportLabel) {
      <span class="px-1" data-test-id="viewport-label">{{ getViewportLabel() }}</span>
    }
  </span>
}
